import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import SHSForm from '../utils/shs-form'
import InputElement from '../utils/input'

import { signInWithEmailAndPass } from '../../actions/auth'
// import { auth } from 'firebaseui'
// import { getAuth, GoogleAuthProvider } from 'firebase/auth'

import { routes } from '../../constants/routes'

const Login = ({ dispatch, fireauth }) => {
    const successFX = () => {
        // nothing for now
    }

    const submitFX = (formData, formId) => {
        dispatch(signInWithEmailAndPass(fireauth, formData.email, formData.password, formId))
    }

    return (
        <div className="container mt-5">
            <div className="box m-auto w-50">
                <div className="text-center mb-3">
                    <img src="/luna_logo_solo.png" alt="Luna Logo" className="m-auto" width="100" />
                </div>
                <h1>Login</h1>
                <SHSForm submitFX={submitFX} successFX={successFX} buttonLabel="Login">
                    <InputElement
                        type="email"
                        id="email"
                        placeholder="user@example.com"
                        label="Email Address"
                        errorMessage="Please provide a valid email address"
                        required />
                    <InputElement
                        type="password"
                        id="password"
                        placeholder="A secret word or phrase"
                        label="Password"
                        errorMessage="Password is required to be a minimum of 8 characters" />
                </SHSForm>
                <p>
                    {/* Don't have an account? <Link to={routes.authRegister}>Register Here</Link><br /> */}
                    Having trouble logging in? <Link to={routes.authPasswordHelp}>Get Login Help</Link>
                </p>
                <p>Don't have an account? <Link to={routes.authRegister}>Register here.</Link></p>
                <div id="firebaseui-auth-container" />
            </div>
        </div>
    )
}

export default connect()(Login)
